import React, { useState } from 'react';
import { withStyles } from "@material-ui/core";
import { Popover, PopoverBody } from 'reactstrap';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';
import Button from 'storybookComponents/Button';
import { useFormik } from 'formik';
import style from "./style";
import { getMeetingIdFromUrl, getMeetingPasswordFromUrl } from "./utils";
import 'bootstrap/dist/css/bootstrap.css';
import "./index.css";
import InputField from "components/InputField"


const VenueForm = ({ placeName, address, onChange, classes, touched, errors, onBlur }) => (
  <div>
    <InputField fullWidth name="placeName" value={placeName} onChange={onChange} onBlur={onBlur} label="Location Name" />
    {touched.placeName && errors.placeName ? (
      <div className={classes.validation}>{errors.placeName}</div>
    ) : null}
    <div className={classes.venueAddress}>Address</div>
    <textarea fullWidth name="address" value={address} onChange={onChange} label="Address" rows="2"
      maxlength="100" />
    {
      touched.address && errors.address ? (
        <div className={classes.validation}>{errors.address}</div>
      ) : null
    }
  </div>
)




const ZoomForm = React.memo(({ zoomLink, meetingId, passcode, classes, touched, errors, onChange, onBlur, setFieldValue }) => {
  const onMeetingUrlChange = (e) => {
    onBlur(e)
    let mid = getMeetingIdFromUrl(e.target.value);
    let pwd = getMeetingPasswordFromUrl(e.target.value)
    let masked = format('XXX XXX XXXXXXXXXXXXXX', new String(mid).replace(/ /g, ""));
    setFieldValue("meetingId", masked);
    // setFieldValue("passcode", pwd);
  }

  console.log("meetingId..", meetingId)
  const getInputValue = (value, mask = false) => value === null ||
    value === undefined
    ? ""
    : mask ? maskInput(value) : value


  const maskInput = (value) => {
    return format('XXX XXX XXXXXXXXXXXXXX', new String(value).replace(/ /g, ""))
  }

  const format = (mask, number) => {
    var s = '' + number, r = '';
    for (var im = 0, is = 0; im < mask.length && is < s.length; im++) {
      r += mask.charAt(im) == 'X' ? s.charAt(is++) : mask.charAt(im);
    }
    return r;
  }

  const handleChange = (event) => {
    let masked = maskInput(event.target.value);
    event.target.value = masked;
    onChange(event)
  }

  const handleBlur = (event) => {
    let masked = maskInput(event.target.value);
    event.target.value = masked;
    onBlur(event)
  }

  return (
    <div>
      <InputField autoComplete="off" name="zoomLink" fullWidth label="Meeting URL"
        value={zoomLink}
        onChange={onChange}
        onBlur={onMeetingUrlChange} />
      {touched.zoomLink && errors.zoomLink ? (
        <div className={classes.validation}>{errors.zoomLink}</div>
      ) : null}

      {/* <InputMask mask="999 999 9999" maskChar={null} value={getInputValue(meetingId)} onChange={onChange} onBlur={onBlur} >
        {() => <TextField name="meetingId" fullWidth label="Meeting ID" />}
      </InputMask> */}

      <InputField autoComplete="off" name="meetingId" fullWidth label="Meeting ID" value={getInputValue(meetingId, true)} onChange={handleChange} onBlur={handleBlur} />
      {
        touched.meetingId && errors.meetingId ? (
          <div className={classes.validation}>{errors.meetingId}</div>
        ) : null
      }
      <InputField autoComplete="off" name="passcode" fullWidth label="Meeting Password" value={getInputValue(passcode)} onChange={onChange} onBlur={onBlur} />
      {
        touched.passcode && errors.passcode ? (
          <div className={classes.validation}>{errors.passcode}</div>
        ) : null
      }
    </div >
  )
})



const validate = values => {
  const errors = {};
  if (values.eventType === "virtual") {
    if (!values.zoomLink) {
      errors.zoomLink = 'Zoom link is required for virtual event';
    }
    else if (!values.zoomLink.startsWith("https://")) {
      errors.zoomLink = 'Please enter valid meeting link';
    }


    if (!values.meetingId) {
      errors.meetingId = 'Meeting id is required for virtual event';
    }

    if (!values.passcode) {
      errors.passcode = 'Passcode is required for virtual event';
    }
  }
  else {
    if (!values.placeName) {
      errors.placeName = 'Place name is required for event';
    }

    if (!values.address) {
      errors.address = 'Address is required for event';
    }
  }

  return errors;
};

const validateButton = values => {
  if (values.eventType === "virtual") {
    if (!values.zoomLink) {
      return "inactive"
    }
    else if (!/https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,}/.test(values.zoomLink)) {
      return "inactive"
    }


    if (!values.meetingId) {
      return "inactive"
    }

    if (!values.passcode) {
      return "inactive"
    }
  }
  else {
    if (!values.placeName) {
      return "inactive"
    }

    if (!values.address) {
      return "inactive"
    }
  }

  return "active";
};



const SimplePopover = ({ onTryToEdit, disabled, children, classes, value, onChange, poupStateChange }) => {
  const [popoverOpen, setPopoverOpen] = useState(false);

  const openPopup = () => {
    if (disabled) return onTryToEdit();
    setPopoverOpen(true);
  }

  const onSubmit = (values) => {
    onChange(values);
    setPopoverOpen(false)
  }

  const formik = useFormik({
    initialValues: { ...value },
    validate,
    onSubmit,
    validateOnBlur: true,
    validateOnChange: true
  });

  const onTabChange = (event) => {
    formik.setFieldValue("eventType", event.target.value)
  }

  React.useEffect(() => {
    if (typeof poupStateChange === "function")
      poupStateChange(popoverOpen)

  }, [popoverOpen])

  return (
    <div className={classes.popoverWidth}>
      <div className="venue-input" id="Popover3" onClick={openPopup}>
        {children(formik.values, popoverOpen)}
      </div>
      <Popover placement="top-end" isOpen={popoverOpen} target="Popover3" className="venue-popover">
        <PopoverBody>
          <form onSubmit={formik.handleSubmit}>
            <div id="Venue-Component" className={classes.popoverBody}>
              <div className={classes.popoverText}>Where is the event happening?</div>
              <RadioGroup className={classes.root} name="VenueLocation" value={formik.values.eventType} onChange={onTabChange}>
                <FormControlLabel value="in_person" control={<Radio />} label="Venue" />
                <FormControlLabel value="virtual" control={<Radio />} label="Zoom" />
              </RadioGroup>
              {
                formik.values.eventType === "virtual" ? <ZoomForm {...formik.values} classes={classes} touched={formik.touched} errors={formik.errors} onChange={formik.handleChange} onBlur={formik.handleBlur} {...formik} />
                  :
                  <VenueForm {...formik.values} touched={formik.touched} errors={formik.errors} classes={classes} onChange={formik.handleChange} onBlur={formik.handleBlur} />
              }
              <Button type="submit" className={classes.button} color="hylyBlue" size="md" state={validateButton(formik.values)}>Done</Button>
            </div>
          </form>
        </PopoverBody>
      </Popover>
    </div>


  );
}

export default withStyles(style)(SimplePopover);

